<template>
    <div class="full-width-overflow-y" :style="styleObj" >
        <HomeHeader
            v-if="fullScreen !== false"
            :returnLabel="returnLabel"
            :useChatBtn="true"
            @clickBackBtn="return3DCity"
            @clickChatBtn="openChatPart"
        />

        <div :class="fullScreen === false ? 'page-part-full' : 'page-part'" v-loading="loading" v-if="viewName === 'index' && null != shopCompanyObj">


            <div class="icon-part-pc" v-show="subView != 'country'">
                <div class="title-part">
                    <div>
                        <h2 tkey="我的賬戶">{{i18n.tkey("lang_my_account")}}</h2>
                    </div>

                    <div>
                        &nbsp;
                    </div>

                </div>

                <div v-if="showIconPart">
                    <IndexHome @clickIcon="clickView" />

                    <el-divider />

                    <div class="title-option-box" v-if="userInfoRef.acccompanycode != null">
                        <div>
                            <countryGroupEditor
                                :showEditBtn="true"
                                @changeView="changeCountryPart"
                            />
                        </div>
                    </div>

                    <IndexCompanyHome @clickIcon="clickView"/>
                </div>
              <div>
                <el-button
                    style="float: right;margin: 8px 50px;font-size: 22px;"
                    type="danger"
                    round
                    @click="clickView('materialEditor')"
                    size="large"
                    class="icon-button"
                >
                  <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                  &nbsp;
                  <span size="large" tkey="出售">{{i18n.tkey("lang_sell")}}</span>
                </el-button>
              </div>


            </div>

            <div class="content-part-pc content-position-pc-1" v-show="subView != 'country'">
                <div class="title-fullwidth">

                        <span tkey="個人信息">{{i18n.tkey("lang_personal_info")}}</span>

                  <el-button
                      style="float: right;margin: 8px"
                      type="primary"
                      plain
                      @click="clickUserEditBtn"
                      size="small"
                      :color="'#32c5d2'"
                      class="icon-button"
                  >
                    <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                    &nbsp;
                    <span tkey="編輯信息">{{i18n.tkey("lang_edit_information")}}</span>
                  </el-button>
                </div>

                <div>
                    <UserInfoEditor
                        v-if="null != userCard"
                        :obj="userCard"
                        :visible="showEditUser"
                        @changeEditUser="changeEditUser"
                        @clickViewBtn="clickView"
                        @save-complete="saveUserCallback"
                    />
                </div>
            </div>

            <div class="content-part-pc content-position-pc-2" v-show="subView != 'country'">
                <div class="title-fullwidth">
                  <span tkey="公司信息">{{i18n.tkey("lang_company_info")}}</span>

                  <el-button
                      style="float: right;margin: 8px"
                      type="primary"
                      plain
                      @click="clickCompanyEditBtn"
                      size="small"
                      :color="'#32c5d2'"
                      class="icon-button"
                  >
                    <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                    &nbsp;
                    <span tkey="編輯信息">{{i18n.tkey("lang_edit_information")}}</span>
                  </el-button>
                  <a
                      class="a-text"
                      :href="eshopopeeUrl"
                      v-if="eshopopeeTag"
                      target="eshopopee"
                  >
                  <el-button
                      style="float: right;margin: 8px"
                      plain
                      :color="'#8E44AD'"
                      size="small"
                  >
                    <font-awesome-icon icon="fa fa-user" />
                    &nbsp;
                    <span tkey="添加用戶">{{i18n.tkey("lang_add_user")}}</span>
                  </el-button>
                  </a>
                </div>

                <div style="height: calc(100% - 50px)">
                    <DepartmentEditor
                        ref="departmentRef"
                        v-if="null != departmentData"
                        :list="departmentData"
                        @save-complete="getInfo"
                    />
                </div>

            </div>
        </div>

        <div class="page-part" v-loading="loading" v-show="viewName !== 'index'" v-if="false !== fullScreen">
<!--            <iframe v-show="viewName === 'chat'" ref="chatRoomIframeDom" :src="chatRoomUrl" seamless="seamless"></iframe>-->

<!--            <div v-if="viewName === 'shop'" style="width: 100%; height: 100%">-->
<!--                &lt;!&ndash;                    <el-scrollbar>&ndash;&gt;-->
<!--                <div style="max-width: calc(100% - 40px); height: 100%; margin: auto; margin-top: 15px;">-->
<!--                    <ShopControllerView :useTitle="false" :showReturnBtn="false"/>-->
<!--                </div>-->

<!--                &lt;!&ndash;                    </el-scrollbar>&ndash;&gt;-->

<!--            </div>-->

            <div v-if="viewName === 'setting'" style="width: 100%; height: 100%">
                <settingComponent @logout-complete="logoutCheck" />
            </div>

<!--            <div v-if="viewName === 'myQuotation'" style="width: 100%; height: 100%">-->
<!--                <el-scrollbar>-->
<!--                    <myQuotation :fullScreen="false" />-->
<!--                </el-scrollbar>-->
<!--            </div>-->

            <div v-if="viewName === 'hall'" style="width: 100%; height: 100%">
                <HallManager
                    @clickReturnBtn="return3DCity"
                    :showReturnBtn="fullScreen == false"
                />
            </div>

        </div>

        <el-dialog
            v-model="openShopVisible"
            :title="i18n.tkey('lang_open_shop_3d')"
            :width="myUtil.isMobile() ? '90%' : '600px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <companyShopInfoEditor :tag="'edit'" :countrycode="userInfoRef.country" @saveComplete="saveShopCallback" />
        </el-dialog>

        <div v-if="reLogin === true" style="width: 1000px; height: 1000px; position: fixed; top: 200vh; left: 0;">
            <LoginComponent
                @login-check-complete="loginCheck"
            />
        </div>

    </div>
<!--  <el-dialog
      v-model="openMaterialVisible"
      :title="''"
      :width="myUtil.isMobile() ? '90%' : '600px'"
      align-center
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
  <MaterialEditor
      @clickReturnBtn="goCloseDialog"
  />
  </el-dialog>-->
</template>

<script setup>
    import SettingComponent from "@/components/phone/settingComponent.vue";
    import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
    import IndexHome from "@/components/shopopee/home/indexHome.vue";
    import UserInfoEditor from "@/components/shopopee/user/userInfoEditor.vue";
    import DepartmentEditor from "@/components/shopopee/department/departmentEditor.vue";
    import LoginComponent from "@/components/loginComponent.vue";
    import {inject, onBeforeMount, ref, toRef, getCurrentInstance, computed, provide, nextTick} from "vue";
    import myUtil from "@/util/util";
    import cardApi from "@/request/api";
    import {useUserinfo} from "@/stores/userinfo";
    import CompanyShopInfoEditor from "@/components/shopopee/company/companyShopInfoEditor.vue";
    import {useCompanyinfo} from "@/stores/companyinfo";
    import countryGroupEditor from "@/components/shopopee/country/countryGroupEditor"
    import companyApi from "@/request/companyApi";
    import IndexCompanyHome from "@/components/shopopee/home/indexCompanyHome.vue";
    import HallManager from "@/components/shopopee/hall/hallManager.vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faGlobe,faPenToSquare } from '@fortawesome/free-solid-svg-icons'
    import MaterialEditor from "@/components/shopopee/material/materialEditor.vue";

    library.add(faGlobe,faPenToSquare)

    const props = defineProps(["fullScreen"])
    const emits = defineEmits(["go-other-view"])

    const i18n = inject("i18n")
    const reload = inject("reload");
    const userInfoRef = toRef(useUserinfo())
    //響應機制的companyinfo
    const companyInfoRef = toRef(useCompanyinfo())
    const { proxy } = getCurrentInstance()
    const chatRoomUrl = ref(null)
    const departmentRef = ref(null)

    const loading = ref(false)

    const iconCol = ref(24)
    const infoCol = ref(24)

    const styleObj = ref({})

    const userCard = ref(null)
    const departmentData = ref(null)

    const viewName = ref("index")
    const subView = ref("index")
    const openShopVisible = ref(false)
    const reLogin = ref(false)

    //店铺控制室使用的company
    const shopCompanyObj = ref(null)

    const showIconPart = ref(true)
    const showEditUser = ref(false)
    const openMaterialVisible = ref(false)

    //是否顯示國家編輯
    const viewPart = ref("home")

    const eshopopeeUrl = computed(() => {
      let url = "javascript: void(0)"

      if (null !== userInfoRef.value.acccompanycode){
        url = myUtil.generateEshopopeeManagerJumpUrl(userInfoRef.value.acccompanycode, userInfoRef.value.login, userInfoRef.value.password, "HRMember.asp?shopForm=shopopee")
      }

      return url
    })

    const eshopopeeTag = computed(() => {
      return null !== userInfoRef.value.acccompanycode
    })

    const { goCompanyView } = inject('phoneView', { goCompanyView: () => {
      proxy.$router.push({name: "myCompany",params: {mfrom: "home"}})}})

    const returnLabel = computed(() => {
        let name = i18n.tkey('lang_3d_business_city')

        if (viewName.value != "index"){
            name = i18n.tkey('lang_return')
        }

        return name
    })

    function changeEditUser(vis){
      showEditUser.value = vis
    }



    function clickCompanyEditBtn(){
      goCompanyView()

    }

    function clickUserEditBtn(){
      showEditUser.value=true
    }
    function getCurrCard(){
      return userCard.value
    }

    function clickAddProduct(){

      openMaterialVisible.value = true
    }

    function goCloseDialog(){
      openMaterialVisible.value = false
    }

    function return3DCity(){
        if (viewName.value === "index"){
            proxy.$router.push({name: "main"})
        }else{
            viewName.value = "index"
        }
    }

    function openChatPart(){
        viewName.value = "chat"
    }

    function getInfo(){
        loading.value = true

        const request = cardApi.queryDepartMemberwork
        const params = request.getParams()

        request.send(params, (res) => {
            loading.value = false

            if (res.code == 200){
                const obj = res.detail

                if (null != obj){
                    if (null != obj.additionalrecord11){
                        if (null != obj.additionalrecord11.addremark1){
                            obj.additionalrecord11 = JSON.parse(obj.additionalrecord11.addremark1)
                        }
                    }

                    if (myUtil.isNotEmpty(obj.id)){
                        myUtil.mergeObj(obj, companyInfoRef.value)
                    }

                    try {
                        userCard.value = obj.list[0].memberworkList[0]
                    }catch (e){
                        console.log(e)
                    }

                    let list = []

                    if (obj.list.length > 0){
                        // list.push(obj.list[0])
                        list = obj.list

                        if (null == departmentData.value){
                            departmentData.value = list
                        }

                    }

                }

            }
        })

    }

    function clickView(view) {
        if(view === "openShop"){
            openShopDialog()
            return
        }

        if (props.fullScreen === false){
            emits('go-other-view', view)

        }else{
            if (view === "mycard"){
                proxy.$router.push({name: "myCard"})
            }else if(view === "shop"){
                proxy.$router.push({name: "shopController"})
            }else if(view === "myQuotation"){
                proxy.$router.push({name: "myQuotation"})
            }else if(view === "mallManager"){
                proxy.$router.push({name: "mallManager"})
            }else if(view === "islandManager"){
                proxy.$router.push({name: "islandManager"})
            }else if(view === "company"){
              proxy.$router.push({name: "myCompany"})
            }else if(view==="materialEditor"){
              proxy.$router.push({name: "materialController"})
            }else{
                viewName.value = view
            }
        }

    }

    function logoutCheck(){
        chatRoomUrl.value = null

        proxy.$router.push({name: "login"})
    }

    function openShopDialog(){
        openShopVisible.value = true
    }

    function saveShopCallback(){
        myUtil.confirmSuccess(
            i18n.tkey("lang_open_shop_success"),
            () => {
                loading.value = true
                reLogin.value = true
            },
            () => {
                loading.value = true
                reLogin.value = true
            }
        )
    }

    function loginCheck(){
        reload()
    }

    function setShopCompanyObj(obj){
        shopCompanyObj.value = obj
        showIconPart.value = false
        nextTick(() => {
            showIconPart.value = true
        })
    }

    function getShopCompanyObj(){
        return shopCompanyObj.value
    }

    function getCompanyInfo(){
        loading.value = true

        const request = companyApi.getCompanyInfo
        const params = request.getParams()

        params.companycode = userInfoRef.value.selectCompanycode

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                shopCompanyObj.value = res.detail

            }
        })

    }

    function changeCountryPart(){
      console.log(subView.value)
        if (subView.value === "index"){
            subView.value = "country"
        }else{
            subView.value = "index"
        }
    }

    function saveUserCallback(){
        departmentRef.value.getDepartCard()
        getInfo()
    }

    provide('shopControlFunc', {
        setShopCompanyObj,
        getShopCompanyObj,
    })

    onBeforeMount(() => {
        if (myUtil.isMobile()){
            iconCol.value = 16
            infoCol.value = 8
        }else{
            iconCol.value = 24
            infoCol.value = 24
        }
        if (props.fullScreen !== false){
            styleObj.value = {
                width: `${window.innerWidth}px`,
                height: `${window.innerHeight}px`
            }

            chatRoomUrl.value = `${proxy.$ShopopeeUrl}/enterChatRoom?login=${userInfoRef.value.login}&password=${userInfoRef.value.password}&tag=3dshopopee`

        }

        if (userInfoRef.value.companycode !== userInfoRef.value.selectCompanycode){
            getCompanyInfo()
        }else{
            shopCompanyObj.value = companyInfoRef.value
        }

        getInfo()

    })

</script>

<style scoped>

.full-width-overflow-y{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    text-align: left;
    position: relative;
}
.title-fullwidth {
  box-sizing: border-box;
  border-bottom: 1px #E4E7ED solid;
  line-height: 2;
  font-size: 21px;
  font-weight: 600;
  width: 100%;
}

@media screen and (min-width: 768px) {
    .icon-part-pc {
        width: calc(100% - 350px);
        height: calc(100% - 60px);
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .content-part-pc {
        width: 350px;
        height: 50%;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .icon-position-pc {

    }

    .content-position-pc-1 {
        position: absolute;
        right: 0px;
        top: 0;
        height: 35%;
    }

    .content-position-pc-2 {
        position: absolute;
        right: 0px;
        top: 35%;
        height: 65%;
    }
}

.page-part {
    width: calc(100% - 30px);
    height: calc(100% - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    position: relative;
    margin: auto;
}

.page-part-full {
    width: calc(100% - 30px);
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    position: relative;
    margin: auto;
}

iframe {
    width: calc(100% + 2px);
    /* height: calc(100% + 163px); */
    height: calc(100% - 10px);
    border: none;
    margin-left: -1px;
}

.title-option-box {
    margin-bottom: 15px;
    text-align: left;
}

.title-part {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

</style>